export default __webpack_public_path__ + "static/media/Janardan photo1 - 022_Janardan.50299c27.jpg";